export const da = {
    pcs: 'stk.',
    pcsWithChars: '/stk',
    Discount: 'Rabat',
    Print: 'Tryk',
    DetailedView: 'Detaljeret oversigt',
    AddToBasket: 'Tilføj til kurven',
};

export const nb = {
    pcs: 'stk.',
    pcsWithChars: '/stk',
    Discount: 'Rabatt',
    Print: 'Trykk',
    DetailedView: 'Detaljert oversikt',
    AddToBasket: 'Legg i handlekurven',
};

export const fi = {
    pcs: 'kpl',
    pcsWithChars: '/kpl',
    Discount: 'Alennus',
    Print: 'Painatus',
    DetailedView: 'Tarkka näkymä',
    AddToBasket: 'Lisää ostoskoriin',
};

export const sv = {
    pcs: 'st.',
    pcsWithChars: '/st.',
    Discount: 'Rabatt',
    Print: 'Tryck',
    DetailedView: 'Detaljer',
    AddToBasket: 'Lägg till i varukorgen',
};

export const at = {
    pcs: 'Stck.',
    pcsWithChars: '/Stck.',
    Discount: 'Rabatt',
    Print: 'Druck',
    DetailedView: 'Detaillierte Übersicht',
    AddToBasket: 'In den Warenkorb legen',
};

export const de = {
    pcs: 'Stck.',
    pcsWithChars: '/Stck.',
    Discount: 'Rabatt',
    Print: 'Druck',
    DetailedView: 'Detaillierte Übersicht',
AddToBasket: 'In den Warenkorb legen',
};

export const fr = {
    pcs: 'unités',
    pcsWithChars: '/unité',
    Discount: 'Réduction',
    Print: 'Impression',
    DetailedView: 'Voir en détails',
AddToBasket: 'Ajouter au panier',
};

export const nl = {
    pcs: 'st.',
    pcsWithChars: 'p. st.',
    Discount: 'Korting',
    Print: 'Bedrukking',
    DetailedView: 'Gedetailleerd overzicht',
    AddToBasket: 'Voeg toe aan winkelwagen',
};

export const en = {
    pcs: 'pcs.',
    pcsWithChars: '/pcs.',
    Discount: 'Discount',
    Print: 'Print',
    DetailedView: 'Detailed view',
    AddToBasket: 'Add to basket',
};
